import * as React from "react";
import { forwardRef } from "react";
const SvgIcConfirmedBold24 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M11.635 19L20.281 4.77927L17.7176 3.22076L10.1914 15.5996L6.0532 11.5133L3.94531 13.648L9.36533 19H11.635Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgIcConfirmedBold24);
export { ForwardRef as ReactComponent };
